import { createReducer, on } from '@ngrx/store';

import { InformationPopupActions } from './information-popup.actions';
import { InformationPopupState, initInformationPopupState } from './information-popup.state';

export const informationPopupReducer = createReducer(
  initInformationPopupState,

  on(
    InformationPopupActions.setPageSettings,
    (state, { page }): InformationPopupState => {
      const newPageSettings = [...state.pageSettings];
      const userPageSettingIndex = newPageSettings.findIndex((entry) => entry.page === page);

      if (userPageSettingIndex >= 0) {
        newPageSettings[userPageSettingIndex] = {
          ...newPageSettings[userPageSettingIndex],
          showExpanded: false,
        };
      } else {
        newPageSettings.push({
          page,
          showExpanded: false,
        });
      }

      return {
        ...state,
        pageSettings: newPageSettings,
      };
    }
  ),
  on(
    InformationPopupActions.savePageSettings,
    (state): InformationPopupState => {
      return {
        ...state,
        loading: true,
      };
    }
  ),
  on(
    InformationPopupActions.savePageSettingsSuccess,
    (state): InformationPopupState => {
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    }
  ),
  on(
    InformationPopupActions.loadSettingsSuccess,
    (state, { settings }): InformationPopupState => {
      return {
        ...state,
        pageSettings: settings,
        loading: false,
        loaded: true,
      };
    }
  ),
  on(
    InformationPopupActions.savePageSettingsError,
    (state, { error }): InformationPopupState => {
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };
    }
  )
);
